import React from "react";
import { colors } from "../../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../../common-components";

const LinkedUserCard = ({ linkedUserName, contactInfo, access }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          height: 120,
          backgroundColor: colors.white,
          WebkitBoxShadow: "0px 0px 7px 3px #00000035",
          borderRadius: 8,
          marginTop: 10,
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 0.6,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: "bold",
              marginLeft: 10,
              marginTop: 10,
            }}
          >
            LINKED USER NAME
          </div>
          <div
            style={{
              fontSize: 14,
              // fontWeight: "bold",
              marginLeft: 10,
              marginTop: 2,
            }}
          >
            {linkedUserName}
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: "bold",
              marginLeft: 10,
              marginTop: 10,
            }}
          >
            CONTACT INFO
          </div>
          <div
            style={{
              fontSize: 14,
              // fontWeight: "bold",
              marginLeft: 10,
              marginTop: 2,
            }}
          >
            {contactInfo}
          </div>
        </div>
        <div
          style={{
            flex: 0.4,
            display: "flex",
            flexDirection: "column",
            backgroundColor: colors.greenLight,
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: "bold",
              marginLeft: 10,
              marginTop: 10,
              color: colors.white,
            }}
          >
            ACCESS TYPE
          </div>
          <div
            style={{
              fontSize: 14,
              // fontWeight: "bold",
              marginLeft: 10,
              marginTop: 2,
              color: colors.white,
            }}
          >
            {access}
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 16,
            }}
          >
            <BaseButtons
              label={"REMOVE"}
              borderRadius={4}
              height={35}
              width={"80%"}
              backgroundColor={colors.orangeDark}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkedUserCard;
